(() => {
  const DAY_SECONDS = 24 * 60 * 60;
  const formatters = new Map();

  const getTimeParts = (timeZone, now) => {
    if (!formatters.has(timeZone)) {
      formatters.set(timeZone, new Intl.DateTimeFormat('en-GB', {
        timeZone,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      }));
    }

    return formatters.get(timeZone).formatToParts(now).reduce((parts, part) => {
      if (part.type !== 'literal') parts[part.type] = Number(part.value);
      return parts;
    }, {});
  };

  const secondsUntilNextMidnight = (timeZone = 'Australia/Brisbane', now = new Date()) => {
    try {
      const { hour, minute, second } = getTimeParts(timeZone, now);
      if (![hour, minute, second].every(Number.isInteger)) return null;
      const elapsed = hour * 3600 + minute * 60 + second;
      return Math.max(1, DAY_SECONDS - elapsed);
    } catch {
      return null;
    }
  };

  const format = seconds => [
    Math.floor(seconds / 3600),
    Math.floor(seconds % 3600 / 60),
    seconds % 60
  ].map(value => String(value).padStart(2, '0')).join(':');

  window.VoltRidgeDailyTimer = Object.freeze({ secondsUntilNextMidnight, format });
})();
